module.exports = __webpack_public_path__ + "img/68000af017d97114db1e420e16c584a4.png";